import React from "react";

const WebPages_Publish = () => {
  return (
    <div className="tutorial-page">
      <h1>WebPages Publish</h1>
      <p>This is the WebPages Publish page content.</p>
    </div>
  );
};

export default WebPages_Publish;
